import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';

import { PaymentService } from './../../../../rest/api/payment.service';
import { PaymentService as PaymentLocalService } from '../../../../services/payment/payment.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-requestdollhouse',
  templateUrl: './requestdollhouse.component.html',
  styleUrls: ['./requestdollhouse.component.scss']
})
export class RequestdollhouseComponent implements OnInit {
  plansData: any;
  loader = true;
  lang: any;

  constructor(
    public paymentService: PaymentService,
    public paymentLocalService: PaymentLocalService,
    public translateService: TranslateService,
  ) {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
  }

  ngOnInit() {
    this.getPlans();
  }

  getPlans() {
    this.paymentService.getPlans(this.lang).subscribe((response: any) => {
      this.plansData = response && response.plan ? response.plan : [];
      this.paymentLocalService.setCardPlan(this.plansData);
    });
  }

}
